var map = {
	"./flag-ca-ES.png": 1010,
	"./flag-cs-CZ.png": 1011,
	"./flag-de-CH.png": 1012,
	"./flag-de-DE.png": 1013,
	"./flag-en-AU.png": 1014,
	"./flag-en-CA.png": 1015,
	"./flag-en-IN.png": 1016,
	"./flag-en-JP.png": 1017,
	"./flag-en-UK.png": 1018,
	"./flag-en-US.png": 1019,
	"./flag-en-USA.png": 1020,
	"./flag-es-AR.png": 1021,
	"./flag-es-CO.png": 1022,
	"./flag-es-EC.png": 1023,
	"./flag-es-ES.png": 1024,
	"./flag-es-LT.png": 1025,
	"./flag-es-MX.png": 1026,
	"./flag-es-US.png": 1027,
	"./flag-es-UY.png": 1028,
	"./flag-fr-BE.png": 1029,
	"./flag-fr-CA.png": 1030,
	"./flag-fr-CH.png": 1031,
	"./flag-fr-FR.png": 1032,
	"./flag-fr-LU.png": 1033,
	"./flag-it-CH.png": 1034,
	"./flag-it-IT.png": 1035,
	"./flag-ja-JP.png": 1036,
	"./flag-nl-BE.png": 1037,
	"./flag-nl-NL.png": 1038,
	"./flag-pl-PL.png": 1039,
	"./flag-pt-PT.png": 1040,
	"./flag-ro-RO.png": 1041,
	"./flag-tr-TR.png": 1042,
	"./flag-zh-CN.png": 1043
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1009;